import React from "react";
// The InputField component is a customizable input field for forms, 
// supporting various attributes like value, placeholder, type, style, and event handling for onChange and onKeyDown.

interface InputFieldProps {
    id?: string;
    value?: string;
    name?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    type?: string;
    className?: string;
    accept?: string;
    multiple?: boolean;
    style?: React.CSSProperties;
    disabled?: boolean;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void; 
}

const InputField: React.FC<InputFieldProps> = ({
    id,
    value,
    name,
    onChange,
    onKeyDown,
    placeholder = '',
    type = 'text',
    className = '',
    accept,
    multiple,
    style,
    disabled = false,
}) => {
    return (
        <input
            id={id}
            type={type}
            value={value} 
            name={name}
            onChange={onChange}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            className={`form-control ${className}`}
            accept={accept}
            multiple={multiple}
            style={style}
            disabled={disabled}
        />
    );
};

export default InputField;